  document.addEventListener('DOMContentLoaded', function() {
    console.log("DOM fully loaded and parsed");

    // Define the path you want to target
    var targetPath = '/collections/mini-mois-produkter';
    console.log("Target path:", targetPath);

    // Get the current path
    var currentPath = window.location.pathname;
    console.log("Current path:", currentPath);

    // Check if the current path matches the target path
    if (currentPath === targetPath) {
        console.log("Path matches, applying background color");
        // Apply the background color
        var headerElement = document.querySelector('.header:not(.drawer-menu).page-width');
        if (headerElement) {
            headerElement.style.backgroundColor = '#000000!important'; // Black background
            console.log("Background color applied");
        } else {
            console.log("Header element not found");
        }
    } else {
        console.log("Path does not match");
    }
});
